import { createActions } from "redux-actions";

const actions = createActions({
    UPDATE_TOKENS: (data) => ({data})
})

export const updateTokens = actions.updateTokens;